/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('./_virtual/_rollupPluginBabelHelpers.js');
var react = require('react');
var isClient = require('./utils/isClient.js');
var safelyParseJson = require('./utils/safelyParseJson.js');

var useStorage = function useStorage(type) {
  return function (initialValue) {
    var _useState = react.useState(initialValue),
        _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
        store = _useState2[0],
        setStore = _useState2[1];

    var storageType = type;

    if (storageType !== 'local' && storageType !== 'session') {
      storageType = 'local';
    }

    storageType += 'Storage';

    var get = function get(key) {
      return safelyParseJson.default(isClient.default ? window[storageType].getItem(key) : store[key]);
    };

    var set = function set(key, value) {
      var valueToStore = value instanceof Function ? value(safelyParseJson.default(store[key])) : value;

      if (isClient.default) {
        window[storageType].setItem(key, JSON.stringify(valueToStore));
      }

      return setStore(function (x) {
        return _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, x), {}, _rollupPluginBabelHelpers.defineProperty({}, key, valueToStore));
      });
    };

    react.useEffect(function () {
      if (isClient.default) {
        Object.keys(store).map(function (k) {
          return window[storageType].setItem(k, JSON.stringify(store[k]));
        });
      }
    }, [store]);
    var storage = store;

    if (isClient.default) {
      storage = window[storageType];
    }

    return _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, storage), {}, {
      get: get,
      set: set
    });
  };
};

exports.default = useStorage;
